"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var am4charts = _interopRequireWildcard(require("@amcharts/amcharts4/charts"));

var am4core = _interopRequireWildcard(require("@amcharts/amcharts4/core"));

var _animated = _interopRequireDefault(require("@amcharts/amcharts4/themes/animated"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _themeUi = require("theme-ui");

var _amChartsApi = _interopRequireDefault(require("../../amChartsApi/amChartsApi"));

var _useAmChart = _interopRequireDefault(require("../../hooks/useAmChart"));

var _useAmChartData2 = _interopRequireDefault(require("../../hooks/useAmChartData"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var getAxisType = function getAxisType(axis) {
  if (axis instanceof am4charts.DateAxis) {
    return 'date';
  }

  if (axis instanceof am4charts.ValueAxis) {
    return 'value';
  }
};

var applyLineConfigure = function applyLineConfigure(_ref) {
  var name = _ref.name,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'black' : _ref$color,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? 2 : _ref$strokeWidth,
      _ref$tooltipText = _ref.tooltipText,
      tooltipText = _ref$tooltipText === void 0 ? '' : _ref$tooltipText,
      _ref$tooltipOrientati = _ref.tooltipOrientation,
      tooltipOrientation = _ref$tooltipOrientati === void 0 ? 'vertical' : _ref$tooltipOrientati,
      _ref$tensionX = _ref.tensionX,
      tensionX = _ref$tensionX === void 0 ? 0.8 : _ref$tensionX,
      _ref$tensionY = _ref.tensionY,
      tensionY = _ref$tensionY === void 0 ? 1 : _ref$tensionY,
      _ref$fillOpacity = _ref.fillOpacity,
      fillOpacity = _ref$fillOpacity === void 0 ? 0 : _ref$fillOpacity,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'black' : _ref$fill,
      amLineSeries = _ref.amLineSeries,
      _ref$tooltipWrap = _ref.tooltipWrap,
      tooltipWrap = _ref$tooltipWrap === void 0 ? true : _ref$tooltipWrap,
      theme = _ref.theme;
  amLineSeries.name = name;
  amLineSeries.tensionX = tensionX;
  amLineSeries.tensionY = tensionY;
  amLineSeries.stroke = am4core.color(color);
  amLineSeries.strokeWidth = strokeWidth;
  amLineSeries.fillOpacity = fillOpacity;
  amLineSeries.fill = am4core.color(fill);
  amLineSeries.tooltipText = tooltipText;
  amLineSeries.tooltip.pointerOrientation = tooltipOrientation;

  _amChartsApi["default"].tooltip(amLineSeries.tooltip).setDefaultStyles(theme);

  if (!tooltipWrap) {
    amLineSeries.tooltip.label.wrap = false;
    amLineSeries.tooltip.label.maxWidth = undefined;
  }

  amLineSeries.interpolationDuration = 0;
  amLineSeries.defaultState.transitionDuration = 500;
  amLineSeries.showOnInit = false;
  return amLineSeries;
};

var createAxis = function createAxis(_ref2) {
  var id = _ref2.id,
      type = _ref2.type;
  var amAxis;

  switch (type) {
    case 'date':
      {
        amAxis = new am4charts.DateAxis();
        break;
      }

    case 'value':
      {
        amAxis = new am4charts.ValueAxis();
        break;
      }
  }

  amAxis.id = id;
  return amAxis;
};

var createLineSeries = function createLineSeries(_ref3) {
  var id = _ref3.id,
      yAxisType = _ref3.yAxisType,
      xAxisType = _ref3.xAxisType,
      yAxisDataId = _ref3.yAxisDataId,
      xAxisDataId = _ref3.xAxisDataId;
  var amLineSeries = new am4charts.LineSeries();

  switch (yAxisType) {
    case 'value':
      {
        amLineSeries.dataFields.valueY = yAxisDataId;
        break;
      }

    case 'date':
      {
        amLineSeries.dataFields.dateY = yAxisDataId;
        break;
      }
  }

  switch (xAxisType) {
    case 'value':
      {
        amLineSeries.dataFields.valueX = xAxisDataId;
        break;
      }

    case 'date':
      {
        amLineSeries.dataFields.dateX = xAxisDataId;
        break;
      }
  }

  amLineSeries.id = id;
  return amLineSeries;
};

var createCursor = function createCursor() {
  return new am4charts.XYCursor();
};

var applyCursorConfig = function applyCursorConfig(_ref4) {
  var amCursor = _ref4.amCursor,
      _ref4$lineY = _ref4.lineY,
      lineY = _ref4$lineY === void 0 ? {} : _ref4$lineY,
      _ref4$lineX = _ref4.lineX,
      lineX = _ref4$lineX === void 0 ? {} : _ref4$lineX,
      xAxisId = _ref4.xAxisId,
      yAxisId = _ref4.yAxisId,
      _ref4$behavior = _ref4.behavior,
      behavior = _ref4$behavior === void 0 ? 'zoomX' : _ref4$behavior,
      snapToLineId = _ref4.snapToLineId,
      amSeriesList = _ref4.amSeriesList,
      amXAxesList = _ref4.amXAxesList,
      amYAxesList = _ref4.amYAxesList;

  var applyCursorLineConfig = function applyCursorLineConfig(_ref5) {
    var amLine = _ref5.amLine,
        enabled = _ref5.enabled,
        _ref5$strokeWidth = _ref5.strokeWidth,
        strokeWidth = _ref5$strokeWidth === void 0 ? 1 : _ref5$strokeWidth,
        _ref5$strokeColor = _ref5.strokeColor,
        strokeColor = _ref5$strokeColor === void 0 ? '#cfd8dc' : _ref5$strokeColor,
        _ref5$strokeOpacity = _ref5.strokeOpacity,
        strokeOpacity = _ref5$strokeOpacity === void 0 ? 1 : _ref5$strokeOpacity,
        _ref5$strokeDasharray = _ref5.strokeDasharray,
        strokeDasharray = _ref5$strokeDasharray === void 0 ? '3 3' : _ref5$strokeDasharray,
        _ref5$fill = _ref5.fill,
        fill = _ref5$fill === void 0 ? '#37474f' : _ref5$fill,
        _ref5$fillOpacity = _ref5.fillOpacity,
        fillOpacity = _ref5$fillOpacity === void 0 ? 0.1 : _ref5$fillOpacity;

    if (!enabled) {
      amLine.disabled = true;
    }

    amLine.strokeWidth = strokeWidth;
    amLine.strokeOpacity = strokeOpacity;
    amLine.strokeDasharray = strokeDasharray;
    amLine.fill = am4core.color(fill);
    amLine.fillOpacity = fillOpacity;
    amLine.stroke = am4core.color(strokeColor);
    return amLine;
  };

  if (snapToLineId) {
    amCursor.snapToSeries = _amChartsApi["default"].list(amSeriesList).findValueById(snapToLineId);
  }

  amCursor.behavior = behavior;

  if (xAxisId) {
    var xAxis = _amChartsApi["default"].list(amXAxesList).findValueById(xAxisId);

    if (getAxisType(xAxis) === 'value') {
      throw Error("Cursor xAxisId can only reference an axis with type 'date' or 'category'.");
    }

    amCursor.xAxis = xAxis;
  }

  if (yAxisId) {
    var yAxis = _amChartsApi["default"].list(amYAxesList).findValueById(yAxisId);

    if (getAxisType(yAxis) === 'value') {
      throw Error("Cursor yAxisId can only reference an axis with type 'date' or 'category'.");
    }

    amCursor.yAxis = yAxis;
  }

  if (lineY.fullWidth) {
    amCursor.fullWidthLineY = true;
  }

  if (lineX.fullWidth) {
    amCursor.fullWidthLineX = true;
  }

  applyCursorLineConfig(_extends({
    amLine: amCursor.lineY
  }, lineY));
  applyCursorLineConfig(_extends({
    amLine: amCursor.lineX
  }, lineX));
  return amCursor;
};

var LineChart = function LineChart(_ref6) {
  var chartId = _ref6.chartId,
      data = _ref6.data,
      config = _ref6.config,
      zoomRange = _ref6.zoomRange,
      onChangeZoomRange = _ref6.onChangeZoomRange,
      props = _objectWithoutPropertiesLoose(_ref6, ["chartId", "data", "config", "zoomRange", "onChangeZoomRange"]);

  var context = (0, _themeUi.useThemeUI)();
  var themeRef = (0, _react.useRef)(context.theme);
  var chart = (0, _useAmChart["default"])(chartId, am4charts.XYChart, _animated["default"]);
  var onDataChange = (0, _react.useCallback)(function (_ref7) {
    var newData = _ref7.newData,
        removedData = _ref7.removedData,
        updatedData = _ref7.updatedData;
    var requestChartRedraw = false;
    newData.forEach(function (dataItem) {
      chart.addData(dataItem);
    });

    if (removedData.length > 0) {
      requestChartRedraw = true;
    }

    updatedData.forEach(function (dataItem) {
      var result = mutateDataItem(dataItem["new"].id, dataItem.key, dataItem.old[dataItem.key], dataItem["new"][dataItem.key]);

      if (!result) {
        requestChartRedraw = true;
      }
    });

    if (requestChartRedraw) {
      invalidateData();
    }
  }, [chart, invalidateData, mutateDataItem]);

  var _useAmChartData = (0, _useAmChartData2["default"])(chart, data, onDataChange),
      invalidateData = _useAmChartData.invalidateData;

  var mutateDataItem = (0, _react.useCallback)(function (dataItemId, dataKey) {
    var chartDataItem = chart.data.find(function (dataItem) {
      return dataItem.id === dataItemId;
    });

    if (!chartDataItem) {
      return false;
    }

    switch (dataKey) {
      case 'value':
        return false;

      default:
        return false;
    }
  }, [chart]);
  (0, _react.useEffect)(function () {
    if (!chart) {
      return;
    }

    chart.xAxes.clear();
    chart.yAxes.clear();
    config.axes.x.forEach(function (axisConfig) {
      chart.xAxes.push(createAxis({
        id: axisConfig.id,
        type: axisConfig.type
      }));
    });
    config.axes.y.forEach(function (axisConfig) {
      chart.yAxes.push(createAxis({
        id: axisConfig.id,
        type: axisConfig.type
      }));
    });
    var lineSeriesArray = [];
    config.lines.forEach(function (lineConfig) {
      var axes = {
        x: _amChartsApi["default"].list(chart.xAxes).findValueById(lineConfig.xAxisId),
        y: _amChartsApi["default"].list(chart.yAxes).findValueById(lineConfig.yAxisId)
      };
      var lineSeries = createLineSeries({
        id: lineConfig.id,
        xAxisDataId: lineConfig.xAxisDataId,
        yAxisDataId: lineConfig.yAxisDataId,
        xAxisType: getAxisType(axes.x),
        yAxisType: getAxisType(axes.y)
      });
      lineSeriesArray.push(lineSeries);
    });
    chart.series.setAll(lineSeriesArray);

    if (config.cursor && config.cursor.enabled) {
      chart.cursor = createCursor();
    }

    if (config.scrollbar && config.scrollbar.enabled) {
      if (config.scrollbar.xAxis && config.scrollbar.xAxis.enabled) {
        chart.scrollbarX = new am4core.Scrollbar();

        if (config.scrollbar.xAxis.zoomToDates) {
          chart.scrollbarX.hidden = true;
        }
      }

      if (config.scrollbar.yAxis && config.scrollbar.yAxis.enabled) {
        chart.scrollbarY = new am4core.Scrollbar();

        if (config.scrollbar.xAxis.zoomToDates) {
          chart.scrollbarX.hidden = true;
        }
      }
    }
  }, [chart, config.axes.x, config.axes.y, config.lines, config.cursor, config.scrollbar]);
  (0, _react.useEffect)(function () {
    if (!chart) {
      return;
    }

    var theme = themeRef.current;

    var applyAxisConfig = function applyAxisConfig(_ref8) {
      var type = _ref8.type,
          _ref8$title = _ref8.title,
          title = _ref8$title === void 0 ? '' : _ref8$title,
          _ref8$titleFontFamily = _ref8.titleFontFamily,
          titleFontFamily = _ref8$titleFontFamily === void 0 ? (0, _themeUi.css)({
        variant: 'textStyles.caption'
      })(theme).fontFamily : _ref8$titleFontFamily,
          _ref8$titleColor = _ref8.titleColor,
          titleColor = _ref8$titleColor === void 0 ? theme.colors.textMediumEmphasis : _ref8$titleColor,
          _ref8$titleFontSize = _ref8.titleFontSize,
          titleFontSize = _ref8$titleFontSize === void 0 ? (0, _themeUi.css)({
        variant: 'textStyles.caption'
      })(theme).fontSize : _ref8$titleFontSize,
          _ref8$titleLetterSpac = _ref8.titleLetterSpacing,
          titleLetterSpacing = _ref8$titleLetterSpac === void 0 ? (0, _themeUi.css)({
        variant: 'textStyles.caption'
      })(theme).letterSpacing : _ref8$titleLetterSpac,
          _ref8$strokeWidth = _ref8.strokeWidth,
          strokeWidth = _ref8$strokeWidth === void 0 ? 1 : _ref8$strokeWidth,
          _ref8$strokeOpacity = _ref8.strokeOpacity,
          strokeOpacity = _ref8$strokeOpacity === void 0 ? 1 : _ref8$strokeOpacity,
          _ref8$strokeColor = _ref8.strokeColor,
          strokeColor = _ref8$strokeColor === void 0 ? '#cfd8dc' : _ref8$strokeColor,
          _ref8$oppositeSide = _ref8.oppositeSide,
          oppositeSide = _ref8$oppositeSide === void 0 ? false : _ref8$oppositeSide,
          _ref8$showGrid = _ref8.showGrid,
          showGrid = _ref8$showGrid === void 0 ? true : _ref8$showGrid,
          _ref8$labelFontSize = _ref8.labelFontSize,
          labelFontSize = _ref8$labelFontSize === void 0 ? (0, _themeUi.css)({
        variant: 'textStyles.caption'
      })(theme).fontSize : _ref8$labelFontSize,
          _ref8$labelColor = _ref8.labelColor,
          labelColor = _ref8$labelColor === void 0 ? theme.colors.textMediumEmphasis : _ref8$labelColor,
          _ref8$minGridDistance = _ref8.minGridDistance,
          minGridDistance = _ref8$minGridDistance === void 0 ? 500 : _ref8$minGridDistance,
          _ref8$baseValue = _ref8.baseValue,
          baseValue = _ref8$baseValue === void 0 ? 0 : _ref8$baseValue,
          min = _ref8.min,
          amAxis = _ref8.amAxis,
          _ref8$tooltipEnabled = _ref8.tooltipEnabled,
          tooltipEnabled = _ref8$tooltipEnabled === void 0 ? true : _ref8$tooltipEnabled,
          _ref8$showLabels = _ref8.showLabels,
          showLabels = _ref8$showLabels === void 0 ? true : _ref8$showLabels,
          _ref8$strictMinMax = _ref8.strictMinMax,
          strictMinMax = _ref8$strictMinMax === void 0 ? false : _ref8$strictMinMax,
          startLocation = _ref8.startLocation,
          endLocation = _ref8.endLocation,
          _ref8$keepSelection = _ref8.keepSelection,
          keepSelection = _ref8$keepSelection === void 0 ? false : _ref8$keepSelection;
      amAxis.renderer.opposite = oppositeSide;
      amAxis.renderer.line.stroke = am4core.color(strokeColor);
      amAxis.renderer.line.strokeWidth = strokeWidth;
      amAxis.renderer.line.strokeOpacity = strokeOpacity;
      amAxis.renderer.grid.template.disabled = !showGrid;
      amAxis.renderer.minGridDistance = minGridDistance;
      amAxis.cursorTooltipEnabled = tooltipEnabled;
      amAxis.renderer.labels.template.fill = am4core.color(labelColor);
      amAxis.renderer.labels.template.fontSize = labelFontSize;
      amAxis.keepSelection = keepSelection;
      amAxis.strictMinMax = strictMinMax;

      if (startLocation !== undefined && startLocation !== null) {
        amAxis.startLocation = 0.5;
      }

      if (endLocation !== undefined && endLocation !== null) {
        amAxis.endLocation = 0.5;
      }

      if (!showLabels) {
        amAxis.renderer.labels.template.hide();
      }

      amAxis.min = min;
      amAxis.title.text = title;
      amAxis.title.fill = am4core.color(titleColor);
      amAxis.title.fontFamily = titleFontFamily;
      amAxis.title.fontSize = titleFontSize;
      amAxis.title.letterSpacing = '1rem';
      amAxis.title.element.attr({
        'letter-spacing': titleLetterSpacing
      });

      if (type === 'value') {
        amAxis.baseValue = baseValue;
      } else if (type === 'date') {
        amAxis.dateFormats.setKey('week', 'd MMM');
        amAxis.periodChangeDateFormats.setKey('week', 'd MMM');
      }

      return amAxis;
    };

    chart.paddingRight = theme.space[4];
    chart.marginRight = 0;
    chart.paddingLeft = 0;
    chart.marginLeft = 0;

    if (chart.scrollbarX || chart.scrollbarY) {
      _amChartsApi["default"].zoomOutButton(chart.zoomOutButton).setDefaultStyles(theme);

      chart.zoomOutButton.marginTop = -theme.space[3];
    } else {
      chart.zoomOutButton.disabled = true;
    }

    if (chart.scrollbarX) {
      _amChartsApi["default"].scrollbar(chart.scrollbarX).setDefaultStyles(theme);

      chart.scrollbarX.parent.paddingTop = theme.space[4];
      chart.scrollbarX.parent.paddingBottom = theme.space[4];
    }

    if (chart.scrollbarY) {
      _amChartsApi["default"].scrollbar(chart.scrollbarY).setDefaultStyles(theme);
    }

    config.axes.x.forEach(function (axisConfig) {
      var xAxis = _amChartsApi["default"].list(chart.xAxes).findValueById(axisConfig.id);

      applyAxisConfig(_extends({
        axis: 'x'
      }, axisConfig, {
        amAxis: xAxis
      }));
    });
    config.axes.y.forEach(function (axisConfig) {
      var yAxis = _amChartsApi["default"].list(chart.yAxes).findValueById(axisConfig.id);

      applyAxisConfig(_extends({
        axis: 'y'
      }, axisConfig, {
        amAxis: yAxis
      }));
    });
    config.lines.forEach(function (lineConfig) {
      var amLineSeries = _amChartsApi["default"].list(chart.series).findValueById(lineConfig.id);

      applyLineConfigure(_extends({}, lineConfig, {
        amLineSeries: amLineSeries,
        theme: theme
      }));
      var axes = {
        x: _amChartsApi["default"].list(chart.xAxes).findValueById(lineConfig.xAxisId),
        y: _amChartsApi["default"].list(chart.yAxes).findValueById(lineConfig.yAxisId)
      };

      if (lineConfig.baseAxis) {
        amLineSeries.baseAxis = axes[lineConfig.baseAxis];
      }
    });

    if (chart.cursor) {
      applyCursorConfig(_extends({}, config.cursor, {
        amCursor: chart.cursor,
        amXAxesList: chart.xAxes,
        amYAxesList: chart.yAxes,
        amSeriesList: chart.series
      }));
    }
  }, [chart, config.axes.x, config.axes.y, config.cursor, config.lines, config.scrollbar.xAxis.axisId, config.scrollbar.xAxis.zoomToDates]);
  (0, _react.useEffect)(function () {
    if (!chart) {
      return;
    }

    var chartReadyListener = chart.events.on('ready', function () {
      zoomRange.forEach(function (zoom) {
        var axis = _amChartsApi["default"].list(chart.xAxes).findValueById(zoom.axisId);

        if (zoom) {
          axis.zoomToDates(zoom.start, zoom.end, false, true);

          if (axis.start < 0) {
            axis.start = 0;
          }

          if (axis.end > 1) {
            axis.end = 1;
          }

          chart.scrollbarX.show();
        }
      });
    });
    return function () {
      chartReadyListener.dispose();
    };
  }, [chart, zoomRange]);
  (0, _react.useEffect)(function () {
    if (!chart || !zoomRange) {
      return;
    }

    var onStartEndChangeEvents = [];
    zoomRange.forEach(function (zoom) {
      var axis = _amChartsApi["default"].list(chart.xAxes).findValueById(zoom.axisId);

      onStartEndChangeEvents.push(axis.events.on('startendchanged', function (ev) {
        if (!ev.target) {
          return;
        }

        var series = chart.series.values[0];
        var startDate = ev.target.getSeriesDataItem(series, ev.target.start);
        var endDate = ev.target.getSeriesDataItem(series, ev.target.end);

        if (startDate && endDate) {
          onChangeZoomRange({
            axisId: zoom.axisId,
            start: startDate.dateX.toISOString(),
            end: endDate.dateX.toISOString()
          });
        }
      }));
    });
    return function () {
      onStartEndChangeEvents.forEach(function (listener) {
        listener.dispose();
      });
    };
  }, [chart, onChangeZoomRange, zoomRange]);
  (0, _react.useEffect)(function () {
    if (!chart || !zoomRange) {
      return;
    }

    zoomRange.forEach(function (zoom) {
      var axis = [].concat(chart.yAxes.values, chart.xAxes.values).find(function (axis) {
        return axis.id === zoom.axisId;
      });

      if (getAxisType(axis) === 'date') {
        axis.zoomToDates(zoom.start, zoom.end, false, true);
      }
    });
  }, [chart, config.zoomable, zoomRange]);
  return (0, _themeUi.jsx)("div", _extends({}, props, {
    id: chartId,
    sx: {
      width: '100%',
      height: 12
    }
  }));
};

LineChart.propTypes = {
  chartId: _propTypes["default"].string.isRequired,
  data: _propTypes["default"].array,
  config: _propTypes["default"].object,
  zoomRange: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    axisId: _propTypes["default"].string,
    start: _propTypes["default"].string,
    end: _propTypes["default"].string
  })),
  onChangeZoomRange: _propTypes["default"].func
};
LineChart.defaultProps = {
  data: null
};
var _default = LineChart;
exports["default"] = _default;